import { Dialog } from "@in/component-library";
import { Grid, GridItem, Text } from "@innovationnorway/lighthouse-components";
import React, { useEffect, useRef, useState } from "react";
import { UserAccount } from "../../../main/models/user-account";
import { useLayout } from "../../hooks/useLayout";
import VerifyEmailConfirmationCode from "../verify-email-confirmation-code/verify-email-confirmation-code";
import VerifyEmailForm from "../verifyEmailForm/verifyEmailForm";

interface EditUserAccountModalProps {
  onClose: () => void;
  modalOpen: boolean;
  userAccount: UserAccount;
}

const EditUserAccountModal = ({ onClose, modalOpen, userAccount }: EditUserAccountModalProps) => {
  const { translations } = useLayout();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [updatedEmail, setUpdatedEmail] = useState<string>();
  const [verificationSent, setVerificationSent] = useState<boolean>(false);

  useEffect(() => {
    if (modalOpen) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [modalOpen]);

  const verificationCreated = (verified: boolean, verificationSent: boolean, recipientEmail: string) => {
    setVerificationSent(verificationSent);
    setUpdatedEmail(recipientEmail);
  };

  return (
    <Dialog
      aria-label="Edit user account information"
      ref={dialogRef}
      onClose={onClose}
      closeButton={{
        onClick: onClose,
        "aria-label": translations.close
      }}
      title={userAccount.account.name}
    >
      {userAccount && (
        <Grid>
          <GridItem spanLarge={10} spanMedium={10} spanSmall={4}>
            <Text variant="lead2">{translations.verifyEmailEditContactInformation}</Text>
          </GridItem>
          <GridItem spanLarge={12} spanMedium={12} spanSmall={4}>
            {verificationSent ? (
              <VerifyEmailConfirmationCode
                accountPublicId={userAccount.account.publicId}
                recipientEmail={updatedEmail}
                onSuccess={onClose}
                onCancel={onClose}
              />
            ) : (
              <VerifyEmailForm
                onSuccess={verificationCreated}
                suggestedEmail={userAccount.emailAddress}
                suggestedPhoneNumber={userAccount.phoneNumber}
                accountPublicId={userAccount.account.publicId}
                suggestedNewletterConsent={userAccount.newsletterConsent}
              />
            )}
          </GridItem>
        </Grid>
      )}
    </Dialog>
  );
};

export default EditUserAccountModal;
